// Field lists for the column-mapping import pop-up. Aliases are the header names people commonly use.
import type { FieldSpec } from "./mapping";
import type { Breakdown } from "../engine/types";

export const REF_FIELDS: FieldSpec[] = [
  { key: "docType", label: "Doc/DLV type", required: true, aliases: ["doc dlv type", "doc type", "document type", "dlv type", "type"] },
  { key: "engCode", label: "Eng. code", aliases: ["eng code", "engineering code", "revised eng code"] },
  { key: "title", label: "Title", required: true, aliases: ["title", "deliverable title", "document title", "description"] },
  { key: "discipline", label: "Discipline", aliases: ["disc code", "discipline", "disc", "dbs", "discipline code"] },
  { key: "defaultWeight", label: "Default weight", aliases: ["default weight", "weight", "default hours", "hours", "budget hours"], hint: "Number (hours)" },
  { key: "chainCode", label: "Doc/DLV chain", aliases: ["doc dlv chain", "doc dlv milestones chains", "milestone chain", "ms chain", "chain", "deliverable chain"] },
  { key: "procChainCode", label: "Procurement chain", aliases: ["procurement chain", "procurement milestones chains", "proc chain"] },
  { key: "category", label: "Category", aliases: ["category", "dlv category"] },
];

export const DOCTYPE_FIELDS: FieldSpec[] = [
  { key: "code", label: "Code", required: true, aliases: ["code", "doc dlv type", "doc type", "type", "document type"] },
  { key: "title", label: "Title", required: true, aliases: ["title", "description", "name"] },
  { key: "category", label: "Category", aliases: ["category", "phase"], hint: "Engineering, Procurement, Construction, Commissioning" },
];

export const MILESTONE_FIELDS: FieldSpec[] = [
  { key: "code", label: "Code", required: true, aliases: ["code", "milestone", "milestone code"] },
  { key: "title", label: "Title", required: true, aliases: ["title", "milestone title", "description", "name"] },
  { key: "active", label: "Active", aliases: ["active", "enabled"], hint: "Y / N" },
  { key: "category", label: "Category", aliases: ["category", "phase"], hint: "Engineering, Procurement, Construction, Commissioning" },
];

export function breakdownFields(t: Breakdown): FieldSpec[] {
  const T = t.toUpperCase();
  return [
    { key: "code", label: `${T} code`, required: true, aliases: ["code", T.toLowerCase(), `${T.toLowerCase()} code`] },
    { key: "title", label: "Title", required: true, aliases: ["title", "description", "name"] },
    { key: "parentCode", label: "Parent", aliases: ["parent", "parent code"] },
    ...(t === "dbs" ? [{ key: "dbsType", label: "Type", aliases: ["type", "dbs type"], hint: "Discipline or Procurement" }] : []),
    { key: "order", label: "Order", aliases: ["order", "sort order", "sequence", "seq"], hint: "Position among siblings in reports (1, 2, 3...)" },
  ];
}

export const BUDGET_FIELDS: FieldSpec[] = [
  { key: "dbs", label: "DBS", required: true, aliases: ["dbs", "code", "discipline", "disc code"] },
  { key: "wbs", label: "WBS", aliases: ["wbs", "area", "unit"] },
  { key: "pbs", label: "PBS (phase)", aliases: ["pbs", "phase"] },
  { key: "hours", label: "Hours", required: true, aliases: ["hours", "budget", "initial budget", "budget hours", "revised budget"] },
];
